
import BookingForm from "../components/bookingFrom";
import Features from "../components/features";

const Home = () => {
    return (
        <div>
            <BookingForm />
            <Features />
        </div>
    );
};

export default Home;    